var _dec, _dec2, _dec3, _class, _class2, _descriptor, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, CustomElement, html } from '@sick-davinci/ce-decorators';
import { style } from './StatusLine.style';
/**
 * The status line informs the user about the status of a process.
 * 
 * Status icon can be changed by setting the value attribute to `pending`, `success` and `error`.
 * 
 * @example
 * ```html
 *  <davinci-status-line>Download File</davinci-status-line>
 *  <davinci-status-line value="success">Download File</davinci-status-line>
 *  <davinci-status-line value="error">Download File</davinci-status-line>
 * ```
 * 
 * @slot {*} text of the status line
 */

export let StatusLine = (_dec = Component({
  style: [style],
  tag: 'davinci-status-line'
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", String), _dec(_class = (_class2 = (_temp = class StatusLine extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "value", _descriptor, this);
  }

  render() {
    return html`
      <div class=status>
        ${this._getStatusIcon()}
      </div>
      <div class=text>
        <slot></slot>
      </div>
    `;
  }

  _getStatusIcon() {
    if (this.value === 'success') {
      return html`<davinci-icon icon="navigation/check"></davinci-icon>`;
    } else if (this.value === 'error') {
      return html`<davinci-icon icon="navigation/close"></davinci-icon>`;
    } else {
      return html`<davinci-spinner></davinci-spinner>`;
    }
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'pending';
  }
})), _class2)) || _class);
//# sourceMappingURL=StatusLine.js.map